import { computed } from 'mobx';

export default class ProductModel {
  id;
  store;

  constructor(store, product) {
    this.store = store;
    this.id = +product.id;
    this.name = product.name;
    this.code = product.code;

    this.pcategory_id = product.pcategory_id;
    this.pcategory_name = product.pcategory_name;
    this.supplier_id = product.supplier_id;
    this.supplier_name = product.supplier_name;
    this.manufacturer_id = product.manufacturer_id;
    this.manufacturer_name = product.manufacturer_name;
    this.calibration_interval = product.calibration_interval;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      code: this.code,
      pcategory_id: this.pcategory_id,
      supplier_id: this.supplier_id,
      manufacturer_id: this.manufacturer_id,
      calibration_interval: this.calibration_interval,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.code = json.code;
    this.pcategory_id = json.pcategory_id;
    this.pcategory_name = json.pcategory_name;
    this.supplier_id = json.supplier_id;
    this.supplier_name = json.supplier_name;
    this.manufacturer_id = json.manufacturer_id;
    this.manufacturer_name = json.manufacturer_name;
    this.calibration_interval = json.calibration_interval;
  }
}



// WEBPACK FOOTER //
// ./src/models/Inventory/InventoryProductModel.js